export default __webpack_public_path__ + "static/media/calendar-EN.c21e2d5b.png";